// 카멜 케이스를 언더바 케이스로 변환
export const camelToSnakeCase = (input: any): any => {
  const converted: Record<string, string> = {};
  for (const key in input) {
    if (Object.prototype.hasOwnProperty.call(input, key)) {
      const value = input[key];
      converted[
        key.replace(/[A-Z]/g, (match: string, index: number) => (index !== 0 ? '_' : '') + match.toLowerCase())
      ] = value;
    }
  }
  return converted;
};

// 언더바 케이스를 카멜 케이스로 변환
// export const snakeToCamelCase = (input: string): string => {
//   return input.replace(/_(?<char>[a-z])/g, (_, char) => char.toUpperCase());
// };
// 테스트

export const snakeToCamelCase = (input: any): Record<string, string | number> => {
  const converted: Record<string, string> = {};
  for (const key in input) {
    if (Object.prototype.hasOwnProperty.call(input, key)) {
      const value = input[key];
      converted[key.replace(/_(?<char>[a-z])/g, (_, char) => char.toUpperCase())] = value;
    }
  }
  return converted;
};
